import { render, staticRenderFns } from "./AreaTrabajo.vue?vue&type=template&id=79b31a5e&"
import script from "./AreaTrabajo.vue?vue&type=script&lang=js&"
export * from "./AreaTrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports